import { Box, CircularProgress, Stack, Typography } from "@mui/material";

const PercentageCircularProgess = ({ progress }) => {
  return (
    <Stack alignItems="center" justifyContent="center" sx={{ minHeight: 100 }}>
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress variant="determinate" value={progress} size={60} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <Typography variant="caption" component="div" color="text.secondary">
            {progress}%
          </Typography>
        </Box>
      </Box>
    </Stack>
  );
};

export default PercentageCircularProgess;
